import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-delete-user-confirmation',
    templateUrl: './delete-user-confirmation.component.html',
    styleUrls: ['./delete-user-confirmation.component.scss'],
})
export class DeleteUserConfirmationComponent {
  @Input() public title = 'Are you sure you want to delete your account?';

  @Input() public message =
    'Your account and all associated data will be permanently deleted after 48 hours. Any successful login during this time will reactivate your account and stop your account being deleted.';

  @Output() private readonly confirm = new EventEmitter<boolean>();

  constructor(
    private readonly userService: UserService,
    private readonly auth: AuthService
  ) {}

  deleteAccount() {
    this.confirm.emit(true);
  }
}
